import { HtmlTag } from "@common/controls/Html";
import classNames from "classnames";
import React from "react";

import "./style.less";

export type Props = {
  className?: string;
  isBackround?: boolean;
  isLoading?: boolean;
  style?: React.CSSProperties;
  width?: string;
  children?: React.ReactNode;
  tag?: string;
};

const SkeletonPreloader = (props: Props) => (
  <HtmlTag
    className={classNames("skeleton_preloader", props.className, {
      background: props.isBackround,
      loading: props.isLoading
    })}
    style={
      {
        ...props.style,
        "--width": props.width ?? "100%"
      } as React.CSSProperties
    }
    tag={props.tag ?? "div"}
  >
    {props.children}
  </HtmlTag>
);
export default SkeletonPreloader;
